var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 3.5,
    fill: "#007FFF",
    fillOpacity: 0.09
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 3.5,
    stroke: "#007FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9996 19H20M16.4033 6.47545C16.713 6.17102 17.133 6 17.5709 6C18.0088 6 18.4287 6.17102 18.7384 6.47545C19.048 6.77988 19.222 7.19277 19.222 7.62329C19.222 8.05381 19.048 8.4667 18.7384 8.77113L9.39674 17.9561C9.21169 18.1381 8.98296 18.2712 8.7317 18.3431L6.4978 18.9839C6.43087 19.0031 6.35993 19.0043 6.29239 18.9873C6.22485 18.9702 6.16321 18.9357 6.11391 18.8872C6.06461 18.8388 6.02947 18.7782 6.01217 18.7118C5.99486 18.6454 5.99604 18.5756 6.01556 18.5098L6.66737 16.3135C6.74066 16.0668 6.87602 15.8422 7.06095 15.6605L16.4033 6.47545Z",
    stroke: "#33363F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/Editicon.f2c4d91a9a08b5b9147e5720b7b6978f.svg";
export { ForwardRef as ReactComponent };